import ProcessedOrdersPage from "./ProcessedOrdersPage";

export default ProcessedOrdersPage;
